import React, { useContext, useEffect, useState, useRef } from "react";
import { HeaderTitle } from "../customComponents/Headers/HeaderTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faUtensils, faBed, faKitMedical, faHome, faPhone, faRestroom, faSmile } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../context/authContext/authContext";
import { useUnidades } from "../../hooks/test/useUnidades";
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import { formatDate } from "../../helpers/formatDate";

export const FormatoJornada = ({ onAction , padreAHijo }) => {
    // console.log("inpeimiendo datos de papa:" + padreAHijo);
    const { 
        stateJornada, 
        stateTurno, 
        setStateTurno,
        user,
        statusUsuarioActual,
        setStatusUsuarioActual,
        eventosCarga,
        setEventosCarga,
    } = useContext(AuthContext);
    const {
        getRegistroEventos
    } = useUnidades();
    const [iniciJornada, setInicioJornada] = useState();

    useEffect(() => {
        loadInfo();
        setStatusUsuarioActual(stateTurno);
    }, []);

    const loadInfo = async() => {
        const eventosJornada = await getRegistroEventos(user.id);

        if (eventosJornada && eventosJornada.ok){
           

            const hora = new Date(eventosJornada.inicio).getHours();
            const minutos = new Date(eventosJornada.inicio).getMinutes();
            const segundos = new Date(eventosJornada.inicio).getSeconds();
            // console.log(hora+":"+minutos+":"+segundos);
            setInicioJornada(hora+":"+minutos+" hrs.");

        
            setEventosCarga(eventosJornada.registros);
            setStatusUsuarioActual(eventosJornada.estatusUsuario);

            let existeFinComida =  false;
            let existeInicioComida = false;

            eventosJornada.registros.map( envetos => {
                existeFinComida =  envetos.tipo_registro.includes( "Fin Comida" );
                existeInicioComida =  envetos.tipo_registro.includes( "Inicio Comida" );
                // console.log(eventosJornada.registros);
                // console.log("existe Fin comida"+ existeFinComida);
                // console.log("existe Inicio comida"+ existeInicioComida);
                
            });

            if( existeFinComida === false && existeInicioComida === true ){
                setStateTurno( {...stateTurno, comida: true})
                
            }
        }
    }


    let date = new Date();
    var now = date.toLocaleTimeString('es-MX');

    const renderSwitch = (param) => {
        // console.log("renderSwitch");
        let switchComida = true;
        let switchDescanso = true;
        let switchServicioMedico = true;
        let switchLlamadaTelefonica = true;
        let switchPermiso = true;
        let switchSanitario = true;
        let switchTienda = true;
                        
        if(param === "Inicio Comida"){
            switchComida = false;
        }else
        if(param === "Fin Comida"){
            switchComida = true;
        }else
        if(param === "Inicio Descanso"){
            switchDescanso = false;
        }else
        if(param === "Fin Descanso"){
            switchDescanso = true;
        }else
        if(param === "Inicio Servicio Medico"){
            switchServicioMedico = false;
        }else
        if(param === "Inicio Permiso"){
            switchPermiso = false;
        }else
        if(param === "Inicio Sanitario"){
            switchSanitario = false;
        }else
        if(param === "Inicio Tienda"){
            switchTienda = false;
        }else
        if(param === "Activo"){
            switchComida = false;
            switchDescanso = false;
            switchServicioMedico = false;
            switchPermiso = false;
            switchSanitario = false;
            switchTienda = false;
        }else{
            switchComida = false;
            switchDescanso = false;
            switchServicioMedico = false;
            switchPermiso = false;
            switchSanitario = false;
            switchTienda = false;
        }

        return (
            <>
                <div id="contenedor-comida" className="col-12 li-list-event">
                    <div className="row">
                        <div className="col-2">
                            <FontAwesomeIcon icon={faUtensils} className="icon-list-event" />
                        </div>
                        <div className="col-8">
                            <p className="listPEvt">COMIDA</p>
                        </div>
                        <div className="col-2">
                            <Form.Check 
                                type="switch"
                                id="custom-switch-comida"
                                className="form-check form-switch"
                                onChange={  (e) => onAction( e, "COMIDA" )}
                                checked= {stateTurno.comida}
                                disabled = {switchComida}
                            />
                        </div>
                    </div>
                </div>
                <div id="contenedor-descanso" className="col-12 li-list-event">
                    <div className="row">
                        <div className="col-2">
                            <FontAwesomeIcon icon={faBed} className="icon-list-event" />
                        </div>
                        <div className="col-8">
                            <p className="listPEvt">DESCANSO</p>
                        </div>
                        <div className="col-2">
                            <Form.Check 
                                type="switch"
                                id="custom-switch-descanso"
                                className="form-check form-switch"
                                onChange={(e) => onAction( e, "DESCANSO" )}
                                checked= {stateTurno.descanso}
                                disabled = { switchDescanso }
                            />
                        </div>
                    </div>
                </div>
                <div className="col-12 li-list-event">
                    <div className="row">
                        <div className="col-2">
                            <FontAwesomeIcon icon={faKitMedical} className="icon-list-event" />
                        </div>
                        <div className="col-8">
                            <p className="listPEvt">SERVICIO MEDICO</p>
                        </div>
                        <div className="col-2">
                            <Form.Check 
                                type ="switch"
                                id ="custom-switch"
                                className ="form-check form-switch"
                                onChange ={(e) => onAction( e, "SERVICIO MEDICO" )}
                                checked = {stateTurno.servicio_medico}
                                disabled = { switchServicioMedico }
                            />  
                        </div>
                    </div>
                </div>
                <div className="col-12 li-list-event">
                    <div className="row">
                        <div className="col-2">
                            <FontAwesomeIcon icon={faSmile} className="icon-list-event" />
                        </div>
                        <div className="col-8">
                            <p className="listPEvt">PERMISO</p>
                        </div>
                        <div className="col-2">
                            <Form.Check 
                                type="switch"
                                id="custom-switch"
                                className="form-check form-switch"
                                onChange={(e) => onAction( e, "PERMISO" )}
                                checked= {stateTurno.permiso}
                                disabled = { switchPermiso }
                            />   
                        </div>
                    </div>
                </div>
                 <div className="col-12 li-list-event">
                    <div className="row">
                        <div className="col-2">
                            <FontAwesomeIcon icon={faRestroom} className="icon-list-event" />
                        </div>
                        <div className="col-8">
                            <p className="listPEvt">SANITARIO</p>
                        </div>
                        <div className="col-2">
                            <Form.Check 
                                type="switch"
                                id="custom-switch"
                                className="form-check form-switch"
                                onChange={(e) => onAction( e, "SANITARIO" )}
                                checked= {stateTurno.sanitario}
                                disabled = { switchSanitario }
                            />  
                        </div>
                    </div>
                </div>
                {/* <div className="col-12 li-list-event">
                    <div className="row">
                        <div className="col-2">
                            <FontAwesomeIcon icon={faHome} className="icon-list-event" />
                        </div>
                        <div className="col-8">
                            <p className="listPEvt">TIENDA</p>
                        </div>
                        <div className="col-2">
                            <Form.Check 
                                type="switch"
                                id="custom-switch"
                                className="form-check form-switch"
                                onChange={(e) => onAction( e, "TIENDA" )}
                                checked= {stateTurno.tienda}
                                disabled = { switchTienda }
                            />    
                        </div>
                    </div>
                </div> */}
            </>
        );
    }
    
    return (
        <>
            <div
                className="offcanvas offcanvas-end"
                data-bs-backdrop="false"
                data-bs-scroll="true"
                tabIndex="-1"
                id="offcanvasJornada"
                aria-labelledby="offcanvasRightLabel"
            >
                <div>
                    <HeaderTitle className="card-header" id="card-header">
                        JORNADA LABORAL
                        <i
                            type="button"
                            className="cerrar-formato-jornada p-2"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </i>
                    </HeaderTitle>
                </div>
                <div className="offcanvas-body">
                    <div className="container">
                        <div id="contenedor-list-eventos" className="row">
                            <div className="col-12">
                                <Accordion defaultActiveKey="1" flush>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>TIEMPOS</Accordion.Header>
                                        <Accordion.Body>
                                            <div id="cardTiempos">
                                                <div className="input-group">
                                                    <div className="col-9">
                                                        <h5>INICIO DE JORNADA: </h5>
                                                    </div>
                                                    <div className="col-3 tiemposCard">
                                                        <h5>{ iniciJornada !== null ? iniciJornada : "00:00:00" }</h5>
                                                    </div>
                                                </div>
                                                {
                                                    eventosCarga && eventosCarga.map((evento)=>{
                                                        if(evento.tipo_registro === "Fin Comida"){

                                                            const ocultarbtncomida = document.getElementById("contenedor-comida");
                                                            
                                                            if(ocultarbtncomida){
                                                                ocultarbtncomida.style.display = 'none';
                                                            }
                                                            
                                                         }
                                                        return(
                                                            <>
                                                                <div className="input-group">
                                                                    <div className="col-9">
                                                                        <h5>{evento.tipo_registro}</h5>
                                                                    </div>
                                                                    <div className="col-3 tiemposCard">
                                                                        <h5>
                                                                        {`${
                                                                            Intl.DateTimeFormat(undefined, { timeStyle: "short" }).format(new Date(evento.fecha_hora))
                                                                            // formatDate(evento.fecha_hora).substring(9, 14)
                                                                        } hrs. `}
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }
                                                 <br/>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                            {
                                padreAHijo !== "" ||  padreAHijo.length === 0 ?
                                    eventosCarga.length === 0 ?
                                        <>
                                            <div id="contenedor-comida" className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faUtensils} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">COMIDA</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch-comida"
                                                            className="form-check form-switch"
                                                            onChange={  (e) =>  onAction( e, "COMIDA" )}
                                                            checked= {stateTurno.comida}
                                                            disabled = {stateJornada !== "Activo" && stateTurno.comida === false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="contenedor-descanso" className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faBed} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">DESCANSO</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch-descanso"
                                                            className="form-check form-switch"
                                                            onChange={(e) => onAction( e, "DESCANSO" )}
                                                            checked= {stateTurno.descanso}
                                                            disabled = { stateJornada !== "Activo" && stateTurno.descanso === false }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faKitMedical} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">SERVICIO MEDICO</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch"
                                                            className="form-check form-switch"
                                                            onChange={(e) => onAction( e, "SERVICIO MEDICO" )}
                                                            checked= {stateTurno.servicio_medico}
                                                            disabled = {stateJornada !== "Activo" && stateTurno.servicio_medico === false }
                                                        />  
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faSmile} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">PERMISO</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch"
                                                            className="form-check form-switch"
                                                            onChange={(e) => onAction( e, "PERMISO" )}
                                                            checked= {stateTurno.permiso}
                                                            disabled = { stateJornada !== "Activo" && stateTurno.permiso === false }
                                                        />   
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faRestroom} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">SANITARIO</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch"
                                                            className="form-check form-switch"
                                                            onChange={(e) => onAction( e, "SANITARIO" )}
                                                            checked= {stateTurno.sanitario}
                                                            disabled = { stateJornada !== "Activo" && stateTurno.sanitario === false }
                                                        />  
                                                    </div>
                                                </div>
                                            </div>
                                            {/*
                                            <div className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faHome} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">TIENDA</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch"
                                                            className="form-check form-switch"
                                                            onChange={(e) => onAction( e, "TIENDA" )}
                                                            checked= {stateTurno.tienda}
                                                            disabled = { stateJornada !== "Activo" && stateTurno.tienda === false }
                                                        />    
                                                    </div>
                                                </div>
                                            </div> */}
                                        </>
                                    :    

                                    renderSwitch(statusUsuarioActual)
                                    
                                :
                                padreAHijo.map( eventoEjecutado => {
                                    return (
                                        <>
                                            {
                                                eventoEjecutado.tipo_registro === "Fin Comida" ? " ":
                                                <div id="contenedor-comida" className="col-12 li-list-event">
                                                    <div className="row">
                                                        <div className="col-2">
                                                            <FontAwesomeIcon icon={faUtensils} className="icon-list-event" />
                                                        </div>
                                                        <div className="col-8">
                                                            <p className="listPEvt">COMIDA</p>
                                                        </div>
                                                        <div className="col-2">
                                                            <Form.Check 
                                                                type="switch"
                                                                id="custom-switch-comida"
                                                                className="form-check form-switch"
                                                                onChange={  (e) =>  onAction( e, "COMIDA" )}
                                                                checked= {stateTurno.comida}
                                                                disabled = {stateJornada !== "Activo" && stateTurno.comida === false}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {
                                                eventoEjecutado.tipo_registro === "Fin Descanso" ? " ": 
                                                <div id="contenedor-descanso" className="col-12 li-list-event">
                                                    <div className="row">
                                                        <div className="col-2">
                                                            <FontAwesomeIcon icon={faBed} className="icon-list-event" />
                                                        </div>
                                                        <div className="col-8">
                                                            <p className="listPEvt">DESCANSO</p>
                                                        </div>
                                                        <div className="col-2">
                                                            <Form.Check 
                                                                type="switch"
                                                                id="custom-switch-descanso"
                                                                className="form-check form-switch"
                                                                onChange={(e) => onAction( e, "DESCANSO" )}
                                                                checked= {stateTurno.descanso}
                                                                disabled = { stateJornada !== "Activo" && stateTurno.descanso === false }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            
                                            
                                            <div className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faKitMedical} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">SERVICIO MEDICO</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch"
                                                            className="form-check form-switch"
                                                            onChange={(e) => onAction( e, "SERVICIO MEDICO" )}
                                                            checked= {stateTurno.servicio_medico}
                                                            disabled = {stateJornada !== "Activo" && stateTurno.servicio_medico === false }
                                                        />  
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faSmile} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">PERMISO</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch"
                                                            className="form-check form-switch"
                                                            onChange={(e) => onAction( e, "PERMISO" )}
                                                            checked= {stateTurno.permiso}
                                                            disabled = { stateJornada !== "Activo" && stateTurno.permiso === false }
                                                        />   
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faRestroom} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">SANITARIO</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch"
                                                            className="form-check form-switch"
                                                            onChange={(e) => onAction( e, "SANITARIO" )}
                                                            checked= {stateTurno.sanitario}
                                                            disabled = { stateJornada !== "Activo" && stateTurno.sanitario === false }
                                                        />  
                                                    </div>
                                                </div>
                                            </div>
                                            {/* 
                                            <div className="col-12 li-list-event">
                                                <div className="row">
                                                    <div className="col-2">
                                                        <FontAwesomeIcon icon={faHome} className="icon-list-event" />
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="listPEvt">TIENDA</p>
                                                    </div>
                                                    <div className="col-2">
                                                        <Form.Check 
                                                            type="switch"
                                                            id="custom-switch"
                                                            className="form-check form-switch"
                                                            onChange={(e) => onAction( e, "TIENDA" )}
                                                            checked= {stateTurno.tienda}
                                                            disabled = { stateJornada !== "Activo" && stateTurno.tienda === false }
                                                        />    
                                                    </div>
                                                </div>
                                            </div> */}
                                            
                                        </>  
                                    );
                                })
                            }
                            
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="col-12 registroEventos">
                                <button 
                                    type="button" 
                                    className="btn btn-danger btn-block mb-4"
                                    onClick={(e) => onAction( e, "INACTIVO" )}
                                    disabled = { stateJornada === "Activo" ? false : stateJornada === "ACTIVO" ? false : true }
                                    >
                                    {
                                        stateTurno.finalizarJornada === false ? "Finalizar jornada" : "Jornada finalizada"
                                    }
                                </button>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}